/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppAiAgentConfigDisablePathParams,
	WhatsAppAiAgentConfigDisableResponse,
} from '../types/WhatsAppAiAgentConfigDisable'

/**
 * POST /campaigns/:campaignId/whatsapp-ai-config/disable
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiAgentConfigController.php WhatsAppAiAgentConfigController::disable
 */
export async function whatsAppAiAgentConfigDisable(
	campaignId: WhatsAppAiAgentConfigDisablePathParams['campaignId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppAiAgentConfigDisableResponse>> {
	return axiosInstance.post(`/campaigns/${campaignId}/whatsapp-ai-config/disable`, undefined, config)
}
